module.exports = __webpack_public_path__ + "img/partner-gofood.0ed9bb71.png";